<!--
  @author:sunluhua
  @time:2020/9/14
  @disc:销售计划导出3
 -->
<template>
  <div class="sale-query">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="经营组织" prop="ces4">
        <ajax-select
          v-model="form.organization"
          type="org"></ajax-select>
      </el-form-item>
      <el-form-item label="客户名称" prop="ces5">
        <search-select
          v-model="form.custom"
          type="customer"
          valueField="id"
          clearable
          placeholder="请输入客户名称"></search-select>
      </el-form-item>
      <el-form-item label="币种" prop="ces3">
        <el-select v-model="form.ces3" placeholder="请选择">
          <el-option
            v-for="item in moneyType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作时间" prop="tareWeightTime">
        <el-date-picker
          v-model="form.tareWeightTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
        <el-button type="primary" v-permission="'0210401'" @click="add">余额差异调整</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      tooltip-effect="light"
      ref="multipleTable">
      <el-table-column
        prop="customerName"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="orgName"
        label="经营组织"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="currencyType"
        label="币种"
        show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-show="scope.row.currencyType == '1'">CNY</span>
          <span v-show="scope.row.currencyType == '2'">USD</span>
          <span v-show="scope.row.currencyType == '3'">EUR</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="金额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="cardSolution"
        label="操作人一卡通"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="操作时间"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
    </div>
    <add-modal :show.sync="addModalVisible" @onform="forms"  :formData="addData"/>
    <automatic :show.sync="automaticVisible"  @onform="forms" :formData="addData"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AjaxSelect from '../../../components/ajaxSelect/index'
import SearchSelect from '../../../components/searchSelect/index'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'
import addModal from './addModal'
export default {
  name: 'saleQuery',
  components: { AjaxSelect, addModal, SearchSelect, MultiCascader },
  data () {
    return {
      form: {
        case3: '',
        tareWeightTime: []
      },
      tableData: [],
      addData: {},
      orderType: [
        { value: '', label: '全部' },
        { value: 1, label: '抹零' },
        { value: 2, label: '仓储费手工开票' },
        { value: 3, label: '客户退款' },
        { value: 4, label: '客户间调账' },
        { value: 5, label: '收款冲销' }
      ],
      moneyType: [
        { value: '', label: '全部' },
        { value: 1, label: 'CNY' },
        { value: 2, label: 'USD' },
        { value: 3, label: 'EUR' }
      ],
      saleType: [
        { value: 1, label: '全部' },
        { value: 2, label: '经营组织1' },
        { value: 3, label: '经营组织2' }
      ],
      list: [
        {
          ces1: '李大志有限公司',
          ces2: '山东中油胜利石化有限公司',
          ces3: 'CNY',
          ces4: '1000,000,000',
          ces5: '11111',
          ces6: '2022-10-27 12:00:00'
        },
        {
          ces1: '李大志有限公司',
          ces2: '山东中油胜利石化有限公司',
          ces3: 'CNY',
          ces4: '110',
          ces5: '11111',
          ces6: '2022-10-27 12:00:00'
        },
        {
          ces1: '李大志有限公司',
          ces2: '山东中油胜利石化有限公司',
          ces3: 'CNY',
          ces4: '9999,999,999.01',
          ces5: '11111',
          ces6: '2022-10-27 12:00:00'
        },
        {
          ces1: '李大志有限公司',
          ces2: '山东中油胜利石化有限公司',
          ces3: 'CNY',
          ces4: '110',
          ces5: '11111',
          ces6: '2022-10-27 12:00:00'
        }
      ],
      citisOptions: [],
      total: 0,
      listState: {
        pageSize: 10,
        pageNo: 1
      },
      automaticVisible: false,
      addModalVisible: false,
      exportForm: {
        size: 1000,
        page: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'getBalanList',
      'getPush',
      'getBalanAdd'
    ]),
    // 搜索
    handleSearch () {
      console.log('jashjdhashdk')
      const params = {
        // adjustType: this.form.ces2[0],
        // receiptNo: this.form.ces1,
        // typeList: this.form.ces2,
        // currencyTypeList: this.form.ces3,
        currencyType: this.form.ces3,
        orgId: this.form.organization,
        customerId: this.form.custom,
        // createTimeStart: this.form.tareWeightTime[0].substring(0, 10),
        // createTimeEnd: this.form.tareWeightTime[1].substring(0, 10),
        ...this.listState
      }
      if (this.form.tareWeightTime === null) {
        console.log(this.form.tareWeightTime)
        this.form.tareWeightTime = []
      }
      if (this.form.tareWeightTime.length === 2) {
        params.createTimeStart = this.form.tareWeightTime[0] + ' 00:00:00'
        params.createTimeEnd = this.form.tareWeightTime[1] + ' 23:59:59'
        console.log(params)
      }
      this.getBalanList(params).then(res => {
        console.log(res, '8888')
        const { list, total, pageNum, pageSize } = res
        this.tableData = list
        this.total = total
        this.listState.pageNo = pageNum
        this.listState.pageSize = pageSize
      })
    },
    // 分页条数变更
    handleSizeChange (val) {
      console.log(val)
      this.listState.pageSize = val
      this.handleSearch()
    },
    // 分页跳转
    handleCurrentChange (val) {
      console.log(val)
      this.listState.pageNo = val
      this.handleSearch()
    },
    resetAccount () {
      console.log('888')
      this.getPush().then(res => {
        console.log(res, '8888')
        this.$message.success('重推电子报账成功')
        this.handleSearch()
      })
    },
    add () {
      this.addData = {}
      this.addModalVisible = true
    },
    forms (e) {
      console.log(e)
      const params = {
        orgId: e.org.id,
        orgName: e.org.name,
        customerId: e.customList[0].id,
        customerName: e.customList[0].name,
        currencyType: e.ces4,
        numChangeType: e.ces1,
        amount: e.ces5,
        remark: e.ces7
      }
      console.log(params)
      this.getBalanAdd(params).then(res => {
        console.log(res, '8888')
        this.$message.success('余额差异调账成功')
        this.handleSearch()
        // const { list, total, pageNo, pageSize } = res.data
        // this.tableData = list
        // this.listState.total = total
        // this.listState.pageNo = pageNo
        // this.listState.pageSize = pageSize
      })
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.form.organization = ''
      this.form.custom = ''
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      this.handleSearch()
    }
  },
  mounted () {
    this.isCheckRecord = ''
    this.form.orderTime = ''
    this.handleSearch()
  }
}
</script>

<style scoped>
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
.export-row {
  margin-top: 10px;
}
.width100{
  width: 100px;
}
</style>
